export class TokenManager {
  constructor(useSessionStorage = false) {
    this.accessToken = null;
    this.refreshToken = null;
    this.useSessionStorage = useSessionStorage;
    
    if (useSessionStorage) {
      this.loadFromSessionStorage();
    }
  }

  setTokens(access, refresh) {
    this.accessToken = access;
    this.refreshToken = refresh;
    
    if (this.useSessionStorage) {
      sessionStorage.setItem('access_token', access);
      sessionStorage.setItem('refresh_token', refresh);
      sessionStorage.setItem('access', access);
      sessionStorage.setItem('refresh', refresh);
    }
  }

  getAccessToken() {
    return this.accessToken;
  }

  getRefreshToken() {
    return this.refreshToken;
  }

  updateAccessToken(access) {
    this.accessToken = access;
    
    if (this.useSessionStorage) {
      sessionStorage.setItem('access_token', access);
      sessionStorage.setItem('access', access);
    }
  }

  clearTokens() {
    this.accessToken = null;
    this.refreshToken = null;
    
    if (this.useSessionStorage) {
      sessionStorage.removeItem('access_token');
      sessionStorage.removeItem('refresh_token');
      sessionStorage.removeItem('access');
      sessionStorage.removeItem('refresh');
    }
  }

  loadFromSessionStorage() {
    if (this.useSessionStorage) {
      this.accessToken = sessionStorage.getItem('access_token');
      this.refreshToken = sessionStorage.getItem('refresh_token');
    }
  }

  hasTokens() {
    return this.accessToken !== null && this.refreshToken !== null;
  }
}
